import axios from 'axios'

export const API = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

API.interceptors.request.use((config) => {
  if (config.headers) {
    config.headers['Timezone-Val'] = Intl.DateTimeFormat().resolvedOptions().timeZone
  }

  return config
})
